// PaymentIcon的图标
const PaymentIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_143_141970)">
        <path d="M3 19H7.90909H12.8182H21V5H3V19Z" stroke="currentColor" strokeWidth="2" />
        <path d="M3 8V10H12H21V8H3Z" fill="currentColor" />
        <path d="M18 14L13 14L12 15L13 16L18 16L18 14Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_143_141970">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default PaymentIcon
